export const SHOW_BUY_PERMITS_EXIT_ORDER_MODAL = "buyPermits/SHOW_BUY_PERMITS_EXIT_ORDER_MODAL";
export const HIDE_BUY_PERMITS_EXIT_ORDER_MODAL = "buyPermits/HIDE_BUY_PERMITS_EXIT_ORDER_MODAL";
export const SHOW_CHECKOUT_SELECT_ADDRESS_MODAL = "buyPermits/SHOW_CHECKOUT_SELECT_ADDRESS_MODAL";
export const HIDE_CHECKOUT_SELECT_ADDRESS_MODAL = "buyPermits/HIDE_CHECKOUT_SELECT_ADDRESS_MODAL";
export const SHOW_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL = "buyPermits/SHOW_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL";
export const HIDE_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL = "buyPermits/HIDE_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL";

export const SHOW_CHECKOUT_SELECT_PHONE_MODAL = "buyPermits/SHOW_CHECKOUT_SELECT_PHONE_MODAL";
export const HIDE_CHECKOUT_SELECT_PHONE_MODAL = "buyPermits/HIDE_CHECKOUT_SELECT_PHONE_MODAL";
export const SHOW_CHECKOUT_SELECT_EMAIL_MODAL = "buyPermits/SHOW_CHECKOUT_SELECT_EMAIL_MODAL";
export const HIDE_CHECKOUT_SELECT_EMAIL_MODAL = "buyPermits/HIDE_CHECKOUT_SELECT_EMAIL_MODAL";

export const SHOW_ALLOWED_VEHICLE_MODAL = "buyPermits/SHOW_ALLOWED_VEHICLE_MODAL";
export const HIDE_ALLOWED_VEHICLE_MODAL = "buyPermits/HIDE_ALLOWED_VEHICLE_MODAL";

export const SHOW_BUY_PERMIT_THANK_YOU_MODAL = "buyPermits/SHOW_BUY_PERMIT_THANK_YOU_MODAL";
export const HIDE_BUY_PERMIT_THANK_YOU_MODAL = "buyPermits/HIDE_BUY_PERMIT_THANK_YOU_MODAL";

export const GET_CHECKOUT_SELECT_ADDRESS_STATES = "pay-citation/GET_CHECKOUT_SELECT_ADDRESS_STATES";
export const SET_CHECKOUT_SELECT_ADDRESS_STATES = "pay-citation/SET_CHECKOUT_SELECT_ADDRESS_STATES";
export const GET_CHECKOUT_SELECT_PHONE_STATES = "pay-citation/GET_CHECKOUT_SELECT_PHONE_STATES";
export const SET_CHECKOUT_SELECT_PHONE_STATES = "pay-citation/SET_CHECKOUT_SELECT_PHONE_STATES";
export const GET_CHECKOUT_SELECT_EMAIL_STATES = "pay-citation/GET_CHECKOUT_SELECT_EMAIL_STATES";
export const SET_CHECKOUT_SELECT_EMAIL_STATES = "pay-citation/SET_CHECKOUT_SELECT_EMAIL_STATES";

export const GET_CHECKOUT_SELECTED_ADDRESS = "pay-citation/GET_CHECKOUT_SELECTED_ADDRESS";
export const SET_CHECKOUT_SELECTED_ADDRESS = "pay-citation/SET_CHECKOUT_SELECTED_ADDRESS";
export const GET_CHECKOUT_SELECTED_BILLING_ADDRESS = "pay-citation/GET_CHECKOUT_SELECTED_BILLING_ADDRESS";
export const SET_CHECKOUT_SELECTED_BILLING_ADDRESS = "pay-citation/SET_CHECKOUT_SELECTED_BILLING_ADDRESS";
export const GET_CHECKOUT_SELECTED_PHONE = "pay-citation/GET_CHECKOUT_SELECTED_PHONE";
export const SET_CHECKOUT_SELECTED_PHONE = "pay-citation/SET_CHECKOUT_SELECTED_PHONE";
export const GET_CHECKOUT_SELECTED_EMAIL = "pay-citation/GET_CHECKOUT_SELECTED_EMAIL";
export const SET_CHECKOUT_SELECTED_EMAIL = "pay-citation/SET_CHECKOUT_SELECTED_EMAIL";

export const GET_BUY_PERMIT_SELECTED_PERMIT = "buy-permit/GET_BUY_PERMIT_SELECTED_PERMIT";
export const SET_BUY_PERMIT_SELECTED_PERMIT = "buy-permit/SET_BUY_PERMIT_SELECTED_PERMIT";
export const EDIT_BUY_PERMIT_SELECTED_PERMIT = "buy-permit/EDIT_BUY_PERMIT_SELECTED_PERMIT";
export const RESET_BUY_PERMIT_SELECTED_PERMIT = "buy-permit/RESET_BUY_PERMIT_SELECTED_PERMIT";
export const GET_BUY_PERMIT_EDIT_VEHICLE = "buy-permit/GET_BUY_PERMIT_EDIT_VEHICLE";
export const SET_BUY_PERMIT_EDIT_VEHICLE = "buy-permit/SET_BUY_PERMIT_EDIT_VEHICLE";

export const SET_BUY_PERMIT_DRAFT_ORDER = "buy-permit/SET_BUY_PERMIT_DRAFT_ORDER";
export const RESET_BUY_PERMIT_DRAFT_ORDER = "buy-permit/RESET_BUY_PERMIT_DRAFT_ORDER";

export const GET_BUY_PERMIT_ORDER_PAYMENT = "buy-permit/GET_BUY_PERMIT_ORDER_PAYMENT";
export const SET_BUY_PERMIT_ORDER_PAYMENT = "buy-permit/SET_BUY_PERMIT_ORDER_PAYMENT";
export const GET_BUY_PERMIT_PAYMENT_ORDER_DETAILS = "buy-permit/GET_BUY_PERMIT_PAYMENT_ORDER_DETAILS";
export const UPDATE_BUY_PERMIT_VEHICLE_LIST = "buy-permit/UPDATE_BUY_PERMIT_VEHICLE_LIST";
export const RESUME_BUY_PERMIT_ORDER_PAYMENT = "buy-permit/RESUME_BUY_PERMIT_ORDER_PAYMENT";

export const SET_UPDATE_BUY_PERMIT_VEHICLE_LIST = "buy-permit/SET_UPDATE_BUY_PERMIT_VEHICLE_LIST";
export const GET_UPDATE_BUY_PERMIT_VEHICLE_LIST = "buy-permit/GET_UPDATE_BUY_PERMIT_VEHICLE_LIST";

export const EMPTY_BUY_PERMIT_CART = "buy-permit/EMPTY_BUY_PERMIT_CART";

export const GET_BUY_PERMIT_PAYMENT_METHODS = "buy-permit/GET_BUY_PERMIT_PAYMENT_METHODS";
export const SET_BUY_PERMIT_PAYMENT_METHODS = "buy-permit/SET_BUY_PERMIT_PAYMENT_METHODS";

export const GET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS = "buy-permit/GET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS";
export const SET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS = "buy-permit/SET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS";

export const GET_BUY_PERMIT_PERMIT_NUMBER = "buy-permit/GET_BUY_PERMIT_PERMIT_NUMBER";
export const SET_BUY_PERMIT_PERMIT_NUMBER = "buy-permit/SET_BUY_PERMIT_PERMIT_NUMBER"

export const GET_BUY_CREDIT_CARD_VERIFICATION = "buy-permit/GET_BUY_CREDIT_CARD_VERIFICATION";
export const SET_BUY_CREDIT_CARD_VERIFICATION = "buy-permit/SET_BUY_CREDIT_CARD_VERIFICATION";

export const SET_TAX_RATE_VERIFICATION = "buy-permit/SET_TAX_RATE_VERIFICATION";
export const GET_TAX_RATE_VERIFICATION = "buy-permit/GET_TAX_RATE_VERIFICATION";

export const SHOW_BUY_PERMIT_UPDATE_VEHICLE_MODAL = "buyPermits/SHOW_BUY_PERMIT_UPDATE_VEHICLE_MODAL";
export const HIDE_BUY_PERMIT_UPDATE_VEHICLE_MODAL = "buyPermits/HIDE_BUY_PERMIT_UPDATE_VEHICLE_MODAL";

export const SET_SELECTED_DEFAULT_VEHICLE_LIST = "buy-permit/SET_SELECTED_DEFAULT_VEHICLE_LIST";

export const GET_COUNTER = "buy-permit/GET_COUNTER";
export const SET_COUNTER = "buy-permit/SET_COUNTER";

export const showBuyPermitsExitOrderModal = () => {
  return {
    type: SHOW_BUY_PERMITS_EXIT_ORDER_MODAL
  }
}


export const hideBuyPermitsExitOrderModal = () => {
  return {
    type: HIDE_BUY_PERMITS_EXIT_ORDER_MODAL
  }
}

export const showCheckoutSelectAddressModal = () => {
  return {
    type: SHOW_CHECKOUT_SELECT_ADDRESS_MODAL
  }
}


export const hideCheckoutSelectAddressModal = () => {
  return {
    type: HIDE_CHECKOUT_SELECT_ADDRESS_MODAL
  }
}

export const showCheckoutSelectBillingAddressModal = () => {
  return {
    type: SHOW_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL
  }
}


export const hideCheckoutSelectBillingAddressModal = () => {
  return {
    type: HIDE_CHECKOUT_SELECT_BILLING_ADDRESS_MODAL
  }
}

export const showCheckoutSelectPhoneModal = () => {
  return {
    type: SHOW_CHECKOUT_SELECT_PHONE_MODAL
  }
}


export const hideCheckoutSelectPhoneModal = () => {
  return {
    type: HIDE_CHECKOUT_SELECT_PHONE_MODAL
  }
}

export const showCheckoutSelectEmailModal = () => {
  return {
    type: SHOW_CHECKOUT_SELECT_EMAIL_MODAL
  }
}


export const hideCheckoutSelectEmailModal = () => {
  return {
    type: HIDE_CHECKOUT_SELECT_EMAIL_MODAL
  }
}

export const getCheckoutSelectAddressStates = (data) => {
  return {
    type: GET_CHECKOUT_SELECT_ADDRESS_STATES,
    payload: data
  }
}

export const setCheckoutSelectAddressStates = (data) => {
  return {
    type: SET_CHECKOUT_SELECT_ADDRESS_STATES,
    payload: data
  }
}

export const getCheckoutSelectPhoneStates = (data) => {
  return {
    type: GET_CHECKOUT_SELECT_PHONE_STATES,
    payload: data
  }
}

export const setCheckoutSelectPhoneStates = (data) => {
  return {
    type: SET_CHECKOUT_SELECT_PHONE_STATES,
    payload: data
  }
}

export const getCheckoutSelectEmailStates = (data) => {
  return {
    type: GET_CHECKOUT_SELECT_EMAIL_STATES,
    payload: data
  }
}

export const setCheckoutSelectEmailStates = (data) => {
  return {
    type: SET_CHECKOUT_SELECT_EMAIL_STATES,
    payload: data
  }
}

export const getCheckoutSelectedAddress = () => {
  return {
    type: GET_CHECKOUT_SELECTED_ADDRESS,
  }
}

export const setCheckoutSelectedAddress = (data) => {
  return {
    type: SET_CHECKOUT_SELECTED_ADDRESS,
    payload: data
  }
}

export const getCheckoutSelectedPhone = () => {
  return {
    type: GET_CHECKOUT_SELECTED_PHONE,
  }
}

export const setCheckoutSelectedPhone = (data) => {
  return {
    type: SET_CHECKOUT_SELECTED_PHONE,
    payload: data
  }
}

export const getCheckoutSelectedEmail = () => {
  return {
    type: GET_CHECKOUT_SELECTED_EMAIL,
  }
}

export const setCheckoutSelectedEmail = (data) => {
  return {
    type: SET_CHECKOUT_SELECTED_EMAIL,
    payload: data
  }
}

export const getCheckoutSelectedBillingAddress = () => {
  return {
    type: GET_CHECKOUT_SELECTED_BILLING_ADDRESS,
  }
}

export const setCheckoutSelectedBillingAddress = (data) => {
  return {
    type: SET_CHECKOUT_SELECTED_BILLING_ADDRESS,
    payload: data
  }
}

export const getBuyPermitSelectedPermit = () => {
  return {
    type: GET_BUY_PERMIT_SELECTED_PERMIT,
  }
}

export const setBuyPermitSelectedPermit = (data) => {
  return {
    type: SET_BUY_PERMIT_SELECTED_PERMIT,
    payload: data
  }
}

export const editBuyPermitSelectedPermit = (data) => {
  return {
    type: EDIT_BUY_PERMIT_SELECTED_PERMIT,
    payload: data
  }
}

export const resetBuyPermitSelectedPermit = (data) => {
  return {
    type: RESET_BUY_PERMIT_SELECTED_PERMIT,
    payload: data
  }
}

export const setBuyPermitDraftOrder = (data) => {
  return {
    type: SET_BUY_PERMIT_DRAFT_ORDER,
    payload: data
  }
}

export const resetBuyPermitDraftOrder = () => {
  return {
    type: RESET_BUY_PERMIT_DRAFT_ORDER
  }
}

export const getBuyPermitEditVehicle = () => {
  return {
    type: GET_BUY_PERMIT_EDIT_VEHICLE,
  }
}

export const setBuyPermitEditVehicle = (data) => {
  return {
    type: SET_BUY_PERMIT_EDIT_VEHICLE,
    payload: data
  }
}

export const getBuyPermitOrderPayment = (data) => {
  return {
    type: GET_BUY_PERMIT_ORDER_PAYMENT,
    payload: data,
  }
}

export const resumeBuyPermitOrderPayment = (data) => {
  return {
    type: RESUME_BUY_PERMIT_ORDER_PAYMENT,
    payload: data,
  }
}

export const setBuyPermitOrderPayment = (data) => {
  return {
    type: SET_BUY_PERMIT_ORDER_PAYMENT,
    payload: data
  }
}

export const getBuyPermitPaymentOrderDetails = () => {
  return {
    type: GET_BUY_PERMIT_PAYMENT_ORDER_DETAILS,
  }
}

export const updateBuyPermitVehicleList = (data) => {
  return {
    type: UPDATE_BUY_PERMIT_VEHICLE_LIST,
    payload: data
  }
}

export const setupdateBuyPermitVehicleList = (data) => {
  return {
    type: SET_UPDATE_BUY_PERMIT_VEHICLE_LIST,
    payload: data
  }
}

export const getupdateBuyPermitVehicleList = (data) => {
  return {
    type: GET_UPDATE_BUY_PERMIT_VEHICLE_LIST,
    payload: data
  }
}

export const showBuyPermitThankYouModal = () => {
  return {
    type: SHOW_BUY_PERMIT_THANK_YOU_MODAL
  }
}


export const hideBuyPermitThankYouModal = () => {
  return {
    type: HIDE_BUY_PERMIT_THANK_YOU_MODAL
  }
}

export const emptyBuyPermitCart = () => {
  return {
    type: EMPTY_BUY_PERMIT_CART
  }
}

export const getBuyPermitPaymentMethods = (data) => {
  return {
    type: GET_BUY_PERMIT_PAYMENT_METHODS,
    payload: data
  }
}

export const setBuyPermitPaymentMethods = (data)=>{
  return{
      type:SET_BUY_PERMIT_PAYMENT_METHODS,
      payload:data
  }
}

export const getBuyPermitAcceptedPaymentMethods = (data) => {
  return {
    type: GET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS,
    payload: data
  }
}

export const setBuyPermitAcceptedPaymentMethods = (data) => {
  return {
    type: SET_BUY_PERMIT_ACCEPTED_PAYMENT_METHODS,
    payload: data
  }
}

export const getBuyPermitGetPermitNumber=(data)=>{
  return{
    type: GET_BUY_PERMIT_PERMIT_NUMBER,
    payload:data
  }
}

export const setBuyPermitGetPermitNumber=(data)=>{
  return{
      type:SET_BUY_PERMIT_PERMIT_NUMBER,
      payload:data
  }
}

export const getBuyCheckCreditCradDetails=(data)=>{
  return{
    type: GET_BUY_CREDIT_CARD_VERIFICATION,
    payload:data
  }
}


export const setBuyCheckCreditCradDetails=(data)=>{
  return{
    type: SET_BUY_CREDIT_CARD_VERIFICATION,
    payload:data
  }
}

export const setTaxRateOrder = (data) =>{
  return{
    type: SET_TAX_RATE_VERIFICATION,
    payload:data
  }
}

export const getTaxRateOrder = (data) =>{
  return{
    type: GET_TAX_RATE_VERIFICATION,
    payload:data
  }
}

export const showBuyPermitUpdateVehicleModal = () => {
  return {
    type: SHOW_BUY_PERMIT_UPDATE_VEHICLE_MODAL
  }
}


export const hideBuyPermitUpdateVehicleModal = () => {
  return {
    type: HIDE_BUY_PERMIT_UPDATE_VEHICLE_MODAL
  }
}

export const setSelectedDefaultVehicle = (data) => {
  return {
    type: SET_SELECTED_DEFAULT_VEHICLE_LIST,
    payload: data
  }
}

export const showAllowedVehicleAlertModal = (data) => {
  return {
    type: SHOW_ALLOWED_VEHICLE_MODAL,
    payload: data
  }
}


export const hideAllowedVehicleAlertModal = () => {
  return {
    type: HIDE_ALLOWED_VEHICLE_MODAL
  }
}

export const getCounter = () => {
  return {
    type: GET_COUNTER,
  }
}


export const setCounter = (data) => {
  return {
    type: SET_COUNTER,
    payload: data
  }
}